import { IReportsContainerState } from './reportsContainerContext';
import { ReportsContainerActionTypes, TReportsContainerAction } from './reportsContainerActions';

export const reportsContainerReducer = (
	state: IReportsContainerState,
	action: TReportsContainerAction,
): IReportsContainerState => {
	switch (action.type) {
		case ReportsContainerActionTypes.SET_REPORTS:
			return {
				...state,
				reports: action.payload.reports,
			};
		case ReportsContainerActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
